<template>
  <button :class="[color, variant]" @click="onclick">
    <slot />
  </button>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '',
      validator: function(value) {
        return ['', 'primary', 'secondary'].indexOf(value) !== -1;
      }
    },
    variant: {
      type: String,
      default: 'contained',
      validator(value) {
        return ['contained', 'text'].indexOf(value) !== -1;
      }
    }
  },
  methods: {
    onclick(e) {
      this.$emit('click', e);
    }
  }
};
</script>

<style lang="scss" scoped="true">
button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  outline: none;
  font-family: inherit;
  font-size: 0.85rem;
  font-weight: 700;
  letter-spacing: 1;
  text-decoration: none;
  text-overflow: ellipsis;
  white-space: nowrap;
  letter-spacing: 1px;
  padding: 15px 20px;
  border-radius: 28px;
  text-transform: uppercase;
  transition: all ease-in-out 300ms;

  &[disabled] {
    opacity: 0.7;
    cursor: not-allowed;
  }

  &.contained {
    transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    border: 1px solid transparent;
    background-color: transparent;
    color: var(--theme-on-default);

    &.primary {
      border-color: var(--theme-primary);
      background-color: var(--theme-primary);
      color: var(--theme-on-primary);
    }

    &.secondary {
      border-color: var(--theme-secondary);
      background-color: var(--theme-secondary);
      color: var(--theme-on-secondary);
    }

    &:not([disabled]) {
      &:hover {
        cursor: pointer;
      }
    }
  }

  &.text {
    transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    border: 1px solid transparent;
    color: var(--theme-default);
    padding: 0.05rem 0.5rem;

    &:not([disabled]) {
      &:hover {
        background-color: var(--theme-default-light);
        cursor: pointer;
      }
    }

    &.primary {
      color: var(--theme-primary);
    }

    &.secondary {
      color: var(--theme-secondary);
    }
  }
}
</style>
